<template>
    <ul class="flex-col m-center list-blank reset-pw">
        <li>
            <h1>Reset password</h1>
        </li>
        <li>
            <label>{{ LANG.login.form.email_short }}</label>
            <input type="text" class="input" v-model="email" />
        </li>
        <li class="mt-20">
            <button class="btn btn-primary no-border" @click="resetPassword">
                Reset password
            </button>
        </li>
        <li class="mt-20">
            <a href="#signin" class="green" @click="$emit('stateChanged', 'signin')">
                Back to sign in
            </a>
        </li>
    </ul>
</template>

<script>

import LANG from "../../i18n/loader"
import API from "../../helper/Api"
import Toastr from "toastr2"

const toastr = new Toastr()

export default {
    emits: [
        'stateChanged',
    ],
    data: () => {
        return {
            LANG,
            email: "",
        }
    },
    methods: {
        resetPassword() {
            API.post("auth", "resetPassword", {
                data: {
                    email: this.email,
                },
                success: () => {
                    toastr.success(
                        LANG.profile.password_reset.text,
                        LANG.profile.password_reset.title
                    )
                },
            })
        },
    },
}
</script>